import { useTranslation } from 'react-i18next';

export const breadcrumbTranslation = (path: string) => () => {
  const { t } = useTranslation();
  const translation = t(`breadCrumbs.${path}`);
  const hasTranslation = !translation.startsWith('breadCrumbs');
  return hasTranslation ? translation : path;
};
